exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".comunication-preferences[data-v-10ca5d96] {\n  margin-bottom: 1.5em;\n}\n.checkbox-wrap[data-v-10ca5d96] {\n  margin: 0.7em 0;\n}\n.choice[data-v-10ca5d96] {\n  margin: 0.5em 0;\n}\n", ""]);

// exports
